<template>
<div>
    <Header />
   <!-- <v-container fill-height> -->
      <v-dialog
            v-model="dialog"
            persistent
            max-width="400"
         >
            <v-card>
            <v-card-text class="pt-5 text-center">
               <h2 class="mb-3">Thank you for Registering</h2>
               <p>An email has been sent to your email address {{ userData.Email }}. Please verifiy your email in order to login.</p>
               </v-card-text>
            </v-card>
         </v-dialog>
         <v-parallax src="../assets/fightbanner.jpg" height="700">
         <v-row justify-center class="my-5">
            <!-- <v-col cols="10" class="mx-auto my-5"> -->
               <v-alert
                  v-model="errorsMessage"
                  prominent
                  type="error"
                  dismissible
               >
                  <v-row align="center">
                  <v-col class="grow">
                     Opps something went wrong {{ this.errorMessage }}
                  </v-col>
                  <!-- <v-col class="shrink">
                     <v-btn>Take action</v-btn>
                  </v-col> -->
                  </v-row>
               </v-alert>
           <!-- </v-col> -->
            <v-col cols="12" class="text-center">
                <v-card
                    elevation="2"
                    max-width="500"
                    class="mx-auto my-5 py-4 px-4 myregcard"
                >   
                <v-row>
                    <v-col class="col-12 text-center">
                        <h2>Register</h2>
                        <!-- <v-img src="../assets/africanring.jpeg" width="200px" class="mx-auto"/> -->
                    </v-col>
                </v-row>
                <h1 class="white--text">
                    Register
                </h1>
                <v-form ref="form" v-model="valid">
                    <v-text-field
                    dark
                    :rules="[rules.required]"
                    v-model="userData.Username"
                    label="Username"
                 ></v-text-field>
                 <v-text-field
                  dark
                    :rules="[rules.required]"
                    v-model="userData.Name"
                    label="Name"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Surname"
                    label="Surname"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Email"
                    label="Email"
                 ></v-text-field>
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.Mobile"
                    label="Phone"
                 ></v-text-field>
                 <!-- <v-text-field
                    :rules="[rules.required]"
                    v-model="userData.Mobile"
                    label="Phone"
                 ></v-text-field> -->
                 <v-text-field
                 dark
                    :rules="[rules.required]"
                    v-model="userData.password"
                    label="Password"
                    type="password"
                 ></v-text-field>
                    <v-btn
                    class="ma-2 white--text"
                    :loading="loading"
                    :disabled="!valid"
                    @click="registerUser()"
                    color="red"
                    >
                    Register User
                    </v-btn>
                </v-form>
                <!-- <v-btn
                    class="ma-2 white--text"
                    color="red"
                    @click="loginpage()"
                    >
                    Login
                    </v-btn> -->
                </v-card>
            </v-col>
        </v-row>
         </v-parallax>
    <!-- </v-container> -->
    <Footer/>
</div>
</template>

<script>
import Header from "../components/frontend/header.vue";
import Footer from "../components/frontend/footer.vue"
import firebase from 'firebase/compat/app';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {setDoc, doc } from "firebase/firestore"; 
import db from '../firebaseConfig'
// import db from '../firestore'

export default {
    components: { Header, Footer },
    data: () => ({
         dialog: false,
        loading: false,
        valid: false,
        rules: {
            required: value => !!value || 'Required.',
        },
        userData: {
               Name: '',
               Surname: '',
               Username: '',
               Date:'',
               Role:'',
               Mobile:'',
               Email: '',
               password: '',
               Status:'',
               image:''
            },
            successMessage: false,
            errorsMessage: false,
            errorMessage:'',
    }),
    methods:{
        loginpage() {
            this.$router.replace('login');
        },
        validate () {
        this.$refs.form.validate()
      },
        registerUser(){
            this.loading = true
            const auth = getAuth()
            createUserWithEmailAndPassword(auth, this.userData.Email, this.userData.password)
               .then(() => {
                  firebase.auth().currentUser.updateProfile({
                     displayName: this.userData.Username
                  }).then(() => {
                        this.successMessage = true
                        // let emailsent = true
                        // this.store.commit('Set_verifiyemailaddress', emailsent)
                        this.verifiyEmail()
                  }).catch(err => {
                     this.errorsMessage = true
                     this.loading = false
                     this.errorMessage = err.message;
                  });
               }).catch(err => {
                  this.errorsMessage = true
                  this.loading = false
                  this.errorMessage = err.message
               });
         },
         verifiyEmail(){
            // this.store.commit('Set_verifiyemailaddress', emailsent)
               const user = firebase.auth().currentUser
                  const actionCodeSettings = {
                      url: `https://africanring.applorduat.co.za/`,
                  // url: `https://africanring.applorduat.co.za/login/?email=${user.email}`,
                  };
               user.sendEmailVerification(actionCodeSettings);
               this.dialog = true
               this.adduserinfo()
         },
         async adduserinfo(){
            this.successMessage = false
          try {
                // this.loading = true
                // var date = date.now()
                let date = new Date();
                const subscriber = "subscriber"
                const newUser = firebase.auth().currentUser


                await setDoc(doc(db, "users", newUser.uid), {
                    Username: this.userData.Username,
                    Name: this.userData.Name,
                    Surname: this.userData.Surname,
                    Email: this.userData.Email,
                    Phone: this.userData.Mobile,
                    Role: subscriber,
                    Status: 'Active',
                    image: null,
                    Date: date.toLocaleString('en-US', {
                        weekday: 'short', // long, short, narrow
                        day: 'numeric', // numeric, 2-digit
                        year: 'numeric', // numeric, 2-digit
                        month: 'long', // numeric, 2-digit, long, short, narrow
                        hour: 'numeric', // numeric, 2-digit
                        minute: 'numeric', // numeric, 2-digit
                        second: 'numeric', // numeric, 2-digit
                    })
                });
                console.log(`Doc Was Successfully Created`);
                this.loading = false
                // this.loading = false
                // this.getusers()
                // this.loading = false
                } catch (e) {
                console.error("Error adding document: ", e);
                }
      },
    }
}
</script>

<style lang="sass">
// .regpage 
//   background-image: url("../assets/boxingbg.jpeg")
//   background-size: cover
//   background-repeat: no-repeat
//   background-position-x: center
//   height: 100%!important

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg 
    background-color: rgb(243 67 54) !important


.myregcard 
  background-color: #000000!important
</style>